const EXPECTED_SALES_OPTIONS = [
  {
    label: '0 - 10000',
    value: '10000',
  },
  {
    value: '30000',
    label: '10001 - 30000',
  },
  {
    value: '60000',
    label: '30001 - 60000',
  },
  {
    value: '80000',
    label: '60001 - 80000',
  },
  {
    value: '120000',
    label: '80001 - 120000',
  },
  {
    value: '150000',
    label: '120001 - 150000',
  },
  {
    value: '300000',
    label: '150001 - 300000',
  },
  {
    value: '500000',
    label: '300001 - 500000',
  },
  {
    value: '500001',
    label: '500001 and more',
  },
];

export default EXPECTED_SALES_OPTIONS;
